import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableAuctanePayIdv = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableAuctanePayIdv);
};
